import useChallengeAttachedPerspectives from './useChallengeAttachedPerspectives';
import CardPerspectiveAndWorldIndicators from '../../../perspectives/CardPerspectiveAndWorldIndicators';
import { type ChallengeSummary } from '@/lib/types';

type ChallengeCardPerspectiveAndWorldIndicatorsProps = {
  challenge: ChallengeSummary;
};

const ChallengeCardPerspectiveAndWorldIndicators = ({
  challenge,
}: ChallengeCardPerspectiveAndWorldIndicatorsProps) => {
  const attachedPerspectives = useChallengeAttachedPerspectives(challenge);

  if (attachedPerspectives.length === 0 && challenge.worlds.length === 0) {
    return null;
  }

  return (
    <CardPerspectiveAndWorldIndicators
      perspectives={attachedPerspectives}
      worlds={challenge.worlds}
    />
  );
};

export default ChallengeCardPerspectiveAndWorldIndicators;
